import config from '../config';
import fetch from 'cross-fetch';
import store from 'store2';
import { getColor, updateProfile , getAllColors} from '../actions/profile';
import { addNotification as notify } from 'reapop';
import { fetchUserByIdForProfile } from './users';
export function getUserColor() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/profile`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getColor(json));
          }
        })
    }
  }
}

export function updateUserProfile(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/profile/updateProfile`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            const message = json.updated === 'true'? "Profile updated successfully!":"Error occurred during profile update.";
            const title = "Status:";
            const status = json.updated === 'true'? 'success' : 'error';
            dispatch(notify({
              title: title,
              message: message,
              status: status,
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));

            dispatch(updateProfile(json));
            dispatch(fetchUserByIdForProfile(userAuth.userId));
          }
        })
    }
  }
}

export function fetchAllColors() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/profile/getColors`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(getAllColors(json));
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/profile.js